export default __webpack_public_path__ + "static/media/icon-react.858088a0.svg";